import {
  PresentationSlide,
  PresentationSlideProps,
} from '@/modules/presentation/PresentationSlide/PresentationSlide';
import { SlideFooterBrandingContext } from '@/modules/presentation/PresentationSlide/SlideFooterBranding.context';

export function BrandedPreviewSlide({
  footer,
  slideDesign,
  ...props
}: PresentationSlideProps) {
  return (
    <PresentationSlide
      {...props}
      slideDesign={slideDesign}
      footer={
        footer && (
          <SlideFooterBrandingContext.Provider value={slideDesign}>
            {footer}
          </SlideFooterBrandingContext.Provider>
        )
      }
    />
  );
}
